import { getHostBaseUrl } from 'utils/browserUtil';

declare var process: { env: { [key: string]: string } };

export const devEnv = process.env.NODE_ENV === 'development';
export const FRONTEND_CONTROLLER_URL = devEnv ? import.meta.env.VITE_FRONTEND_CONTROLLER_URL : getHostBaseUrl();
export const DISTRIBUTION_CENTER_BACKEND_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/pcdBackendService`;
export const CN_MGMT_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/noteService/api`;
export const PARTNER_MGMT_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/partnerService/api`;
export const PARTNER_MGMT_PI_API_URL = `${PARTNER_MGMT_API_URL}/partners/individualpartners`;
export const PARTNER_MGMT_LE_API_URL = `${PARTNER_MGMT_API_URL}/partners/legalpartners`;
export const PRODUCTS_AND_SERVICES_BACKEND_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/pcoBackendService`;
export const WEALTH_OVERVIEW_BACKEND_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/wealthOverviewBackendService`;
export const INVESTMENT_PROFILE_BACKEND_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/investmentProfileBackendService`;
export const BR_MGMT_BACKEND_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/pcmBrBackendService`;
export const TASK_VIEWER_BACKEND_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/pmkTaskViewerBackEndService/api`;
export const NOTIFICATION_CENTER_BACKEND_WS_URL = devEnv
  ? 'wss://pcm-prospect-frontend.pcm-development.gcrm.sehlat.io/ws'
  : `wss://${window.location.hostname}/ws`;
export const NOTIFICATION_CENTER_BACKEND_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/pmkNotificationCenterBackEndService`;
export const PSH_PORTAL_BACKEND_API_URL = `/backEnd/pshPortalBackendServiceHost`;
export const PARTNER_MGMT_USER_FEEDBACK_API_URL = `${PARTNER_MGMT_API_URL}/user-feedbacks`;
export const SMALL_SCREEN_WIDTH = '900px';
export const CLM_TO_CRM_URL = 'crm:///?command=OpenPartnerFlatView&PartnerNr=';
export const BR_PURPOSE_BACKEND_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/brPurposeBackendService`;
export const PARTNER_MGMT_GDPR_API_URL = `${PARTNER_MGMT_API_URL}/gdpr`;
export const PARTNER_ORCHESTRATOR_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/partnerOrchestratorService`;
export const GRAVITY_UAT_URL = 'https://gra-fe-gravity2-uat.juliusbaer.com/gravity/';
export const GRAVITY_URL = 'https://gra-fe-gravity2.juliusbaer.com/gravity/';
export const CDT_BACKEND_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/cdtBackendService`;
export const BP_TOOL_URL = 'https://eambusinessprocessing.juliusbaer.com/ch/';
export const TWO_LEVEL_NAV_FRAME_HEIGHT = 'calc(100% - 218px)';
export const ONE_LEVEL_NAV_FRAME_HEIGHT = 'calc(100% - 174px)';
export const TOPBAR_HEIGHT = 60;
export const RISK_PROFILE_API_URL = `${FRONTEND_CONTROLLER_URL}/backEnd/riskProfileBackendService`;
